module.exports = "/_next/static/images/bitcoin_gold-70a96009d1c1c142aa070b252bde7e56.png";